import axios from "axios";
import { API_URL } from "../constant/Constant";
class VoucherService {

  async applyVoucher(voucherCode, userId, orderAmount, planId) {
    return await axios.get(`${API_URL}api/v1/applyVoucher?voucherCode=${voucherCode}&userId=${userId}&orderAmount=${orderAmount}&planId=${planId}`, {});
  }
}
export default new VoucherService();
